import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { CorporateMap } from "./CorporateMap";
import { CorporateAddress } from "./CorporateAddress";
import { CorporateCommunication } from "./CorporateCommunication";

export const CorporatePageContent = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Map",
      key: "corporateMap",
      children: (
        <CorporateMap/>
      ),
    },
    {
      label: "Address",
      key: "corporateAddress",
      children: (
        <CorporateAddress/>
      ),
    },
    {
      label: "Communication",
      key: "corporateCommunication",
      children: (
        <CorporateCommunication/>
      ),
    },
  ];

  return (
      <Tabs
        activeKey={query?.get("thirdChildActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`);
        }}
      ></Tabs>
  );
};